// Module
var code = "<h2 class=\"interiorSectionHeading\"> Inbox </h2> <p>View your bills and letters anytime with the new Inbox!</p> ";
// Exports
export default code;